module.exports = __webpack_public_path__ + "assets/07895e4a9e438a84f0855adc5c696f59.png";